/**
 * AdSense Configuration
 * 
 * Add your ad slot IDs here once you create them in Google AdSense.
 * Go to: adsense.google.com → Ads → By ad unit → Create ad unit
 * 
 * To enable an ad placement, replace the empty string with your slot ID.
 * To disable a placement, set it to empty string or null.
 */

const AD_CONFIG = {
  // Your AdSense Publisher ID (already in index.html)
  publisherId: 'ca-pub-8607565924578094',
  
  // Set to true to show placeholder boxes during development
  testMode: false,
  
  // Ad Slot IDs - Add your slot IDs from AdSense dashboard here
  slots: {
    // Landing page sidebar (300x250 rectangle)
    landingSidebar: '9362936039',
    
    // In-feed ad on landing page (between content sections)
    landingInFeed: '7493440263',
    
    // Blog page sidebar
    blogSidebar: '9362936039',
    
    // In-article ad (within blog post content)
    blogInArticle: '7493440263',
  },
  
  // Pages/sections where ads should NOT appear (for premium feel)
  excludedPages: [
    '/checkout',
    '/membership', // Keep membership page ad-free for conversions
    '/settings',
    '/admin',
  ],
  
  // Check if current page should show ads
  shouldShowAds: (pathname) => {
    return !AD_CONFIG.excludedPages.some(page => pathname.startsWith(page));
  },
};

export default AD_CONFIG;
